import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { ReactComponent as CloseIcon } from '../../../../assets/icons/close-grey.svg'

import useStyles from './styles'

function MultiFieldItem({ value, label, className, deleteHandler }) {
  const classes = useStyles()

  return (
    <div key={value} className={classnames(classes.selectedValueWrapper, className)}>
      <div className={classes.selectedValueLabel}>{label}</div>
      <CloseIcon onClick={() => deleteHandler(value)} className={classes.selectedValueRemove} />
    </div>
  )
}

MultiFieldItem.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  label: PropTypes.string,
  className: PropTypes.string,
  deleteHandler: PropTypes.func
}

export default MultiFieldItem
